// load sass
import '../sass/common.scss'; //scssの読み込み
// modernizr // webp
import {modernizer}  from "./common/modernizr.js";
modernizer();
// load imageSwitch
import {imageSwitch} from "./common/sub_imageswtch.js";
imageSwitch();


window.addEventListener('load',() => {

  if (window.matchMedia('(max-width: 480px)').matches) {
    // IS SMART
    // console.log('done');
    document.getElementsByClassName('smart-hamburger')[0].onclick = () => {
      if (document.getElementsByClassName('smart-hamburger')[0].classList.contains('active')) {
        document.getElementsByClassName('smart-hamburger')[0].classList.remove('active')
        document.getElementsByClassName('menu-contents')[0].classList.remove('active')
      } else {
        document.getElementsByClassName('smart-hamburger')[0].classList.add('active')
        document.getElementsByClassName('menu-contents')[0].classList.add('active')
      }
    } //onclick
  } else {

    if (document.getElementsByClassName('main-visual')[0]) {
      let header_height = document.getElementById('header-content').getBoundingClientRect().height
      let window_height = window.innerHeight
      document.getElementsByClassName('main-visual')[0].style.marginTop = header_height + 'px'
      document.getElementsByClassName('main-visual')[0].style.height = window_height - header_height + 'px'
    }
  }


  if (document.getElementsByClassName('main-visual')[0]) {
    let main_visual = document.getElementsByClassName('main_slide')
    let cnt = 0
    let slide_interval  = 6000


    function clear_alide (slide_material) {
      for (let i = 0; i < slide_material.length; i++) {
        slide_material[i].classList.remove('active')
      }
    }

    const main_slider = () => {
      if (cnt >= main_visual.length) {
        cnt = 0;
      }
      clear_alide(main_visual)
      main_visual[cnt].classList.add('active')
      cnt ++
    }
    setInterval(main_slider,slide_interval)
  }


  // find school information
  function clear_all (slide_elements) {
    for (let index = 0; index < slide_elements.length; index++) {
      slide_elements[index].classList.remove('active')
    }
  }

  if (document.getElementsByClassName('school-place')[0]) {
    let slide_elements = document.getElementsByClassName('school-place')[0].children
    let count = 0;
    let interval_time = 6000
    const slide_show = () => {
      if (count >= slide_elements.length) {
        count = 0;
      }
      clear_all(slide_elements)
      slide_elements[count].classList.add('active')
      count ++
    }
    setInterval(slide_show,interval_time)
    // slide_elements[0].classList.add('done')
  }

  if (document.getElementsByClassName('hover-bubble')[0]) {
    let button_material = document.getElementsByClassName('hover-bubble')

    for (let index = 0; index < button_material.length; index++) {
      // button_material[index]
      button_material[index].addEventListener('mouseover', (event) => {
        button_material[index].firstElementChild.style.left = event.offsetX + 'px'
        button_material[index].firstElementChild.style.top = event.offsetY + 'px'
      })
      button_material[index].addEventListener('mouseout', (event) => {
        button_material[index].firstElementChild.style.left = event.offsetX + 'px'
        button_material[index].firstElementChild.style.top = event.offsetY + 'px'
      })
    }
  }



  /* ADMIN */
  // admin/trial_session/detail/ CONFIRM RESERVE POPUP
  if (document.getElementById('confirm_reserve') !== null) {
    document.getElementById('confirm_reserve').onclick = () => {
      document.getElementsByClassName('js_blur')[0].classList.add('standby')

      setTimeout(() => {
        document.getElementsByClassName('js_blur')[0].classList.add('active')
        document.getElementById('confirm_popup').classList.add('standby')
        setTimeout(() => {
          document.getElementById('confirm_popup').classList.add('active')
        }, 400)
      }, 125)
    } //onclick

    document.getElementById('cancel').onclick = () => {
      document.getElementById('confirm_popup').classList.remove('active')

      setTimeout(() => {
        document.getElementsByClassName('js_blur')[0].classList.remove('active')
        document.getElementById('confirm_popup').classList.remove('standby')

        setTimeout(() => {
          document.getElementsByClassName('js_blur')[0].classList.remove('standby')
        }, 200)
      }, 400)
    } //onclick

  }
  // END admin/trial_session/detail/ CONFIRM RESERVE POPUP


  // SMART PHONE APP LIKE NAVIGATIONS.
  if (document.getElementById('smart-navigation')) {
    const smoothScroll = () => {
      let startY = window.pageYOffset
      const scroll = () => {
        startY = window.pageYOffset
        console.log(startY)
        let y = startY - (startY - 0) / 20 - 1
        window.scrollTo(0, y)
        if (y < 0) return
        requestAnimationFrame(scroll)
      }
      requestAnimationFrame(scroll)
    }

    let pageTop = document.getElementById('js_page-top')
    pageTop.onclick = () => {
      smoothScroll()
    } // end page top.


    // show menu
    let menuBtn = document.getElementById('js_contents_menu')
    function removeMenu () {
      // remove
      setTimeout(() => {
        document.getElementById('smart_contents').classList.remove('active')
        setTimeout(() => {
          document.getElementById('smart_contents').classList.remove('standby')
        }, 250)
      }, 200)
    }

    menuBtn.onclick = () => {
      if (menuBtn.classList.contains('active')) {
        menuBtn.classList.remove('active')
        document.getElementsByClassName('smart_popup')[0].classList.remove('active')

        setTimeout(() => {
          removeMenu ()
        }, 400)
      } else {
        //NOT ACTIVE.
        if (shareBtn.classList.contains('active')) {
          shareBtn.classList.remove('active')
          document.getElementsByClassName('smart_share')[0].classList.remove('active')
        }
        menuBtn.classList.add('active')
        document.getElementById('smart_contents').classList.add('standby')
        setTimeout(() => {
          document.getElementById('smart_contents').classList.add('active')
          setTimeout(() => {
            document.getElementsByClassName('smart_popup')[0].classList.add('active')
          }, 250)
        }, 100)
      }
    }
    // end show menu.

    //share button.
    let shareBtn = document.getElementById('js_share')
    shareBtn.onclick = () => {
      if (shareBtn.classList.contains('active')) {
        // remove
        shareBtn.classList.remove('active')
        document.getElementsByClassName('smart_share')[0].classList.remove('active')
        setTimeout(() => {
          document.getElementById('smart_contents').classList.remove('active')
          setTimeout(() => {
            document.getElementById('smart_contents').classList.remove('standby')
          }, 250)
        }, 100)
      } else {
        // NOT ACTIVE.
        if (menuBtn.classList.contains('active')) {
          menuBtn.classList.remove('active')
          document.getElementsByClassName('smart_popup')[0].classList.remove('active')
        }
        document.getElementsByClassName('smart_popup')[0].classList.remove('active')
        shareBtn.classList.add('active')
        document.getElementById('smart_contents').classList.add('standby')
        setTimeout(() => {
          document.getElementById('smart_contents').classList.add('active')
          setTimeout(() => {
            document.getElementsByClassName('smart_share')[0].classList.add('active')
          }, 250)
        }, 100)
      }
    }

    //end share button.
  }
  // END SMART PHONE APP LIKE NAVIGATIONS.

})
// end onload event
